import React from "react";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Button from "react-bootstrap/Button";
import "./Css/SubscribedCard.css";

const SubscribedCard = ({ credit, onViewDetails, formatDate }) => {
	const totalCredits = Number(credit?.total_credits || 0);
	const usedCredits = Number(credit?.used_credits || 0);
	const computedAvailable = totalCredits - usedCredits;
	const availableCredits = Number(
		credit?.available_credits != null ? credit.available_credits : computedAvailable
	);
	const safeAvailable = availableCredits > 0 ? availableCredits : 0;
	const isExpired = credit?.expiration_date
		? new Date(credit.expiration_date) < new Date()
		: false;

	const amountPaid = String(credit?.amount_Paid || "0").replace(/^Rs\.?\s*/i, "");
	const currency = credit?.currency || credit?.currency_type || "LKR";
	const paidBy = credit?.paid_By || credit?.paid_by || "-";
	const expiryText = formatDate ? formatDate(credit?.expiration_date) : "-";
	const usagePercent = totalCredits > 0 ? Math.min(100, Math.round((usedCredits / totalCredits) * 100)) : 0;
	return (
		<article
			className={`subscribed-card ${isExpired ? "subscribed-card--disabled" : ""}`}
		>
			<header className="subscribed-card__header">
				<div className="subscribed-card__header-top">
					<h3 className="subscribed-card__title">{credit?.package_name || "Package Name goes here"}</h3>
					{isExpired && (
						<span className="subscribed-card__status subscribed-card__status--expired">
							Expired
						</span>
					)}
				</div>
				<p className="subscribed-card__fee">
					Credit Fee : <span>{amountPaid} {currency}</span>
				</p>
			</header>

			<div className="subscribed-card__body">
				<div className="subscribed-card__total-row">
					<span className="subscribed-card__total-value">{totalCredits}</span>
					<span className="subscribed-card__total-label">Total Credits</span>
				</div>

				<div className="subscribed-card__progress" aria-label="Usage progress">
					<div
						className="subscribed-card__progress-track"
						role="progressbar"
						aria-valuemin={0}
						aria-valuemax={100}
						aria-valuenow={usagePercent}
					>
						<div
							className="subscribed-card__progress-fill"
							style={{ width: `${usagePercent}%` }}
						/>
					</div>
					<span className="subscribed-card__progress-label">{usagePercent}% used</span>
				</div>

				<hr className="subscribed-card__divider" />

				<p className="subscribed-card__credits-left">Credits Left</p>
				<div className="subscribed-card__badge-row">
					<div className="subscribed-card__badge subscribed-card__badge--used">Used: {usedCredits} Credits</div>
					<div className="subscribed-card__badge subscribed-card__badge--available">Available: {safeAvailable} Credits</div>
				</div>

				<div className="subscribed-card__info-row">
					<HourglassEmptyOutlinedIcon className="subscribed-card__info-icon subscribed-card__info-icon--danger" />
					<span className="subscribed-card__info-label">{isExpired ? "Expired on" : "Expires on"}</span>
					<span className="subscribed-card__info-value subscribed-card__info-value--danger">{expiryText}</span>
				</div>

				<div className="subscribed-card__info-row">
					<AccountCircleOutlinedIcon className="subscribed-card__info-icon subscribed-card__info-icon--success" />
					<span className="subscribed-card__info-label">Paid by :</span>
					<span className="subscribed-card__info-value subscribed-card__info-value--success">{paidBy}</span>
				</div>

				<div className="subscribed-card__actions">
					<Button
						type="button"
						onClick={onViewDetails}
						className="btn btn-primary btn-sm subscribed-card__view-btn"
						title="View More Details"
					>
						<RemoveRedEyeIcon fontSize="small" />
						View Details
					</Button>
				</div>
			</div>
		</article>
	);
};

export default SubscribedCard;
